import {
  SafetyMessageAndLogoActionTypes,
  SafetyMessageAndLogoState
} from './types';
import { Reducer } from 'redux';

const initialState: SafetyMessageAndLogoState = {
  error: undefined,
  submitting: false,
  data: undefined,
  safetyMessageLogo: undefined,
  safetyMessageLogoUpdated: false,
  isNewRecordAdded: false,
  type: 'ADD'
};

const reducer: Reducer<SafetyMessageAndLogoState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SafetyMessageAndLogoActionTypes.FETCH_SAFETY_MESSAGE_AND_LOGO_START: {
      return {
        ...state,
        loading: true
      };
    }

    case SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_START: {
      return {
        ...state,
        data: undefined,
        submitting: true
      };
    }

    case SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_SUCCESS: {
      return {
        ...state,
        submitting: false,
        safetyMessageLogoUpdated: true
      };
    }

    case SafetyMessageAndLogoActionTypes.UPDATE_SAFETY_MESSAGE_AND_LOGO_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload,
        safetyMessageLogoUpdated: false
      };

    default:
      return state;
  }
};

export { reducer as SafetyMessageAndLogoReducer };
